// @ts-nocheck
import { Category } from "@insite/client-framework/Services/CategoryService";
import {
    GetAlsoPurchasedProductCollectionApiV2Parameter,
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    LoadFeaturedCategory,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { BrandModel } from "@insite/client-framework/Types/ApiModels";
import { addToChainAfter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

interface Parameter {
    carouselId: string;
    carouselType: string;
    relatedProductType: string;
    seedWithManuallyAssigned: string;
    displayProductsFrom: string;
    selectedCategoryIds: string[];
    numberOfProductsToDisplay: number;
    isProductDetailsPage: boolean;
    productId?: string;
    isProductListPage: boolean;
    category?: Category;
    isBrandDetailsPage: boolean;
    brand?: BrandModel;
    isShellEdit?: boolean;
}

interface Props {
    getProductCollectionParameter?:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    extraProductCollectionParameter?:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
}

type HandlerType = Handler<Parameter, Props>;
const LoadAllProducts: HandlerType = props => {
    const {
        parameter: { carouselType, numberOfProductsToDisplay, displayProductsFrom, selectedCategoryIds },
        getState,
    } = props;
    if (carouselType !== "allProducts") {
        return;
    }
    const state = getState();
    if (!getSettingsCollection(state).websiteSettings.enableDynamicRecommendations) {
        return;
    }
    const categoryId = displayProductsFrom === "selectedCategories" ? selectedCategoryIds?.[0] : undefined;
    props.getProductCollectionParameter = {
        pageSize: numberOfProductsToDisplay,
        categoryId,
    };
};

addToChainAfter(chain, LoadFeaturedCategory, LoadAllProducts);
